import { useEffect } from "react";
import { useRibbon } from "../Contexts/RibbonProvider";
import "./RibbonPopup.css";

const RibbonPopup = () => {
  const { ribbons, removeRibbon } = useRibbon();

  useEffect(() => {
    if (!ribbons.length) return;
    const timer = setTimeout(() => {
      removeRibbon(0);
    }, 5000);
    return () => clearTimeout(timer);
  }, [ribbons, removeRibbon]);

  if (!ribbons.length) return null;

  return (
    <div className="ribbonPopup">
      <div
        className="ribbonPopupBar"
        style={
          ribbons[0].type === "error" ? { backgroundColor: "#bd1919" } : {}
        }
      ></div>
      <div className="ribbonPopupMessage">{ribbons[0].message}</div>
    </div>
  );
};

export default RibbonPopup;
